import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import { UtilService } from 'src/app/service/util';

import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DanfeService {

  url = `${environment.urlApiProtheus}/wsrdanfe`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService,
  ) {
  }

  getDanfeII(CSERIE: string, CDOCUMENTO:string): Observable<any> {

    const httpOptions = this.utilService.filtrosHttpOptions();
    httpOptions.responseType = 'blob' as 'json';

    return this.httpClient.get(`${this.url}/2/${CDOCUMENTO}/${CSERIE}`, httpOptions);
  }

  getDanfeEntrada(CCHAVE: string): Observable<any> {

    const httpOptions = this.utilService.filtrosHttpOptions();
    httpOptions.responseType = 'blob' as 'json';

    return this.httpClient.get(`${this.url}/entrada/${CCHAVE}`, httpOptions);
  }

}
